import clsx from "clsx";

import seamlessTexturePng from "../Noise/seamless_texture.png";

/**
 * Seamless texture overlay that stretches to fill its closest positioned ancestor.
 */
export function SeamlessTexture(props: React.ComponentPropsWithRef<"div">) {
  return (
    <div
      {...props}
      className={clsx("tw-absolute tw-inset-0 tw-mix-blend-soft-light", props.className)}
      style={{
        backgroundImage: `url(${seamlessTexturePng.src})`,
        backgroundRepeat: "repeat",
        ...props.style,
      }}
    />
  );
}
